import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet';

import LoginCallback from '@/containers/login/callback';
import EmailChange from '@/containers/login/email-change';
import PasswordReset from '@/containers/login/password-reset';
import { Loading } from '@hogwarts/ui-components-core';
import { Forms } from '@hogwarts/ui-components-forms';
import { Route, Routes } from 'react-router-dom';
import App from './app';
import VerifyCandidate from './checks/verifyCandidate/verifyCandidate';

const AppContainer = ({ children }) => (
  <React.Fragment>
    <Helmet>
      <meta charSet={'utf-8'} />
      <title>Sign In Central Record</title>
      <meta
        name={'description'}
        content={
          'Discover Sign In Central Record, an online hub for schools to manage checks, inspector evaluations, and teaching staff effortlessly.'
        }
      />
    </Helmet>
    <Suspense fallback={<Loading showLogo />}>
      <Forms>{children}</Forms>
    </Suspense>
  </React.Fragment>
);

const PageRoot = () => (
  <Routes>
    <Route
      path={'/callback'}
      element={
        <AppContainer>
          <LoginCallback />
        </AppContainer>
      }
    />
    <Route
      path={'/passwordreset'}
      element={
        <AppContainer>
          <PasswordReset />
        </AppContainer>
      }
    />
    <Route
      path={'/emailchange'}
      element={
        <AppContainer>
          <EmailChange />
        </AppContainer>
      }
    />
    <Route path={'/checks/verifycandidate'} element={<VerifyCandidate />} />
    <Route
      path={'*'}
      element={
        <AppContainer>
          <App />
        </AppContainer>
      }
    />
  </Routes>
);

export default PageRoot;
